export const data = {
  episode: 1,
  title: "Specialties of Prophet Muhammad SAW",
  video: "https://www.youtube.com/watch?v=VOUp3ZZ9t3A&list=PLAEA99D24CA2F9A8F",
};
